module.exports = __webpack_public_path__ + "img/logo.90b8464e.png";